// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nProvider } from '@lingui/react';
import { ApolloProvider } from '@apollo/react-hooks';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import Themes from 'bizom-mui/lib/Themes';

import catalogAr from './locales/ar/messages';
import catalogBn from './locales/bn/messages';
import catalogEn from './locales/en/messages';
import catalogFa from './locales/fa/messages';
import catalogHi from './locales/hi/messages';
import catalogKn from './locales/kn/messages';
import catalogMl from './locales/ml/messages';
import catalogMr from './locales/mr/messages';
import catalogUr from './locales/ur/messages';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import App from './App';
import client from 'apolloClient';
import theme from './utils/theme';
import * as serviceWorker from './serviceWorker';
import { isCordovaApp } from './utils/isCordovaApp';
import { LocaleContextProvider, LocaleContext } from './contexts/LocaleContext';

const catalogs = {
  ar: catalogAr,
  bn: catalogBn,
  en: catalogEn,
  fa: catalogFa,
  hi: catalogHi,
  kn: catalogKn,
  ml: catalogMl,
  mr: catalogMr,
  ur: catalogUr,
};

const AppWithGraphQL = () => (
  <ApolloProvider client={client}>
    <LocaleContextProvider>
      <LocaleContext.Consumer>
        {({ direction, language }) => (
          <I18nProvider language={language} catalogs={catalogs}>
            <Themes theme={theme} direction={direction}>
              <App />
            </Themes>
          </I18nProvider>
        )}
      </LocaleContext.Consumer>
    </LocaleContextProvider>
  </ApolloProvider>
);

const rootEl = document.getElementById('root');

if (rootEl) {
  ReactDOM.render(<AppWithGraphQL />, rootEl);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
if (!isCordovaApp()) {
  serviceWorker.register();
}
